import errorDetails from "./state_error-details";
import { newDate } from "@/utils";

export default {
    error: {
        message: "",
        data: {},
        buttonText: "Back",
        buttonAction: false,
        show: false
    },
    isInitialised: {
        session: false,
        metadata: false
    },
    toastMessages: [],
    landingUrl: false,
    windowInnerWidth: 400,
    areFiltersCompleted: false,
    userRequestsAvailability: false,
    numberOfPages: 3,
    pageNumbers: { "reserve-appointment": 1, "about-you": 2, "checkout": 3 },
    serverTimeDiffSeconds: 0,// ADD this value to local timestamp to estimate server timestamp
    isSessionExpiresSoonModalRelevant: false,
    userHasDismissedSessionExpiresSoonModal: false,
    isSessionExpiredModalRelevant: false,
    clinics: {
        isLoading: false,
        data: false,
        dropdownLocations: []
    },
    dcs: {
        isLoading: false,
        data: false,
        typeaheadDCs: [],
        dropdownDCs: []
    },
    stripe: {
        publishableKeyTest: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_TEST,
        publishableKeyLive: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_LIVE
    },
    stripeProducts: {
        isLoading: false,
        data: false
    },
    //  Availability slots for a selected DC at some location
    //  "Shared" between slots for booking NPC and ROF appointments, because... different screens will use different instances of app
    slots: {
        isLoading: false,
        data: [],
        dc: false,
        thereAreOtherDCs: false
    },
    //  Upcoming appointments - used when calculating whether slots are available
    appointments: {
        isLoading: false,
        data: []
    },


    availability: {
        params: {
            locationId: 0,
            clinic: {},
            dcId: 0,
            dc: {},
            shifts: { early: false, afternoon: true, late: false },
            shift: "afternoon",
            //  When user is reserving NPC, and was referred to a specific DC: broaden out to all DCs
            showAllDCs: false,
            slots: {
                startsAt: newDate(),
                endsAt: newDate()
            },
            appointments: {
                startsAt: newDate(),
                endsAt: newDate(),
                isFirstSetOfAppointments: true
            }
        },

        // selectedSlot: false,
        // shiftsWithSlots: [],

        results: {
            allSlots: {},
            availableSlots: [],
            currentDaysSlots: [],
            dcs: [],
            dc: false,
            dcId: 0
        },

        // isCompilingAvailableSlots: false,
        // carouselWantsToLoadMoreAppointments: false,

        outcomes: {
            finishedLoadingSlots: false,
            finishedLoadingAppointments: false,
            loadedFirstSetOfAppointments: false,
            apiReturnedSlots: false,
            canLoadMoreAppointments: false,
            isNoAvailabilityVisible: false,
            isNoMoreAvailabilityVisible: false,
            isScrollUpButtonVisible: false,
            isMakeAppointmentModalVisible: false
        },

    },

    urlPath: "",
    queryStringParams: {},
    session: {
        sessionId: "",
        isLoading: false,
        data: false,
        loadError: {
            isError: false,
            status: 200,
            message: ""
        }
    },
    settings: {},
    dropdownReferralSources: [],
    dobDays: [
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
        { value: 13, text: "13" },
        { value: 14, text: "14" },
        { value: 15, text: "15" },
        { value: 16, text: "16" },
        { value: 17, text: "17" },
        { value: 18, text: "18" },
        { value: 19, text: "19" },
        { value: 20, text: "20" },
        { value: 21, text: "21" },
        { value: 22, text: "22" },
        { value: 23, text: "23" },
        { value: 24, text: "24" },
        { value: 25, text: "25" },
        { value: 26, text: "26" },
        { value: 27, text: "27" },
        { value: 28, text: "28" },
        { value: 29, text: "29" },
        { value: 30, text: "30" },
        { value: 31, text: "31" }
    ],
    dobMonths: [
        { value: 0, text: "Jan" },
        { value: 1, text: "Feb" },
        { value: 2, text: "Mar" },
        { value: 3, text: "Apr" },
        { value: 4, text: "May" },
        { value: 5, text: "Jun" },
        { value: 6, text: "Jul" },
        { value: 7, text: "Aug" },
        { value: 8, text: "Sep" },
        { value: 9, text: "Oct" },
        { value: 10, text: "Nov" },
        { value: 11, text: "Dec" }
    ],
    dobYears: [],
    errorDetails: { ...errorDetails },
    scratchData: false//    This is for display in scratch results panel
};
